import { endPoints } from 'api/';
import { GET_CONDITION } from 'actions/types';

/**
 * @description Get a list of all item conditions.
 * @param {string} itemId Item id.
 * @returns Array of condition objects
 */
function query(itemId) {
  const query = {
    where: {
      entity_id: itemId,
      entity_type: 'inventory',
    },
  };
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: GET_CONDITION,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        const condition = await apiClient(endPoints.GET_CONDITION, {}, query);
        return condition;
      },
    };
    dispatch(action);
  };
}

export default query;
